import dayjs from 'dayjs'
import { formatDateTime } from '@/utils'

// Notes younger than a day show a compact age (2m, 5h); older ones show the
// full timestamp.
export function formatNoteTimestamp(iso: string): string {
  const then = dayjs(iso)
  const now = dayjs()
  const minutes = now.diff(then, 'minute')
  if (minutes < 1) return 'just now'
  if (minutes < 60) return `${minutes}m`
  const hours = now.diff(then, 'hour')
  if (hours < 24) return `${hours}h`
  return formatDateTime(iso, '-', true)
}

// A source note's date shown as a plain calendar date (e.g. "Jul 17, 2026").
export function formatNoteDate(iso: string): string {
  return dayjs(iso).format('MMM D, YYYY')
}
